const announcementClose = () => {
  document.querySelector('.announcement-bar-section').style.display = 'none';
  var header = document.querySelector(".section-header");
  header.classList.remove("no-announcement");
}

 const sideBarSearchBtnAction = () =>{
    document.querySelector('.header__searc').classList.add('active');
    // document.querySelector('.menu-drawer-container').classList.remove('menu-opening')
 }
  const sideBarLoginBtnAction = () =>{
    document.querySelector('.login-drawer').classList.add('active');
    // document.querySelector('.menu-drawer-container').classList.remove('menu-opening')
 }
  const sideBarCartBtnAction = () =>{
    document.querySelector('cart-drawer').classList.add('active');
    // document.querySelector('.menu-drawer-container').classList.remove('menu-opening')
 }

 document.addEventListener('DOMContentLoaded', () => {
  // shop menu 2뎁스 클릭(활성화)하면 1뎁스 current표시
  const shopMenu = document.getElementById('Details-shop-menu');

  if (shopMenu) {
    const hasActiveLink = shopMenu.querySelector('a.menu-drawer__menu-item--active');

    if (hasActiveLink) {
      // details 자체에 표시
      shopMenu.classList.add('is-current');

      // summary에도 표시
      const summary = shopMenu.querySelector('summary');
      if (summary) {
        summary.classList.add('is-current');
      }
    }
  }
});